var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "add-chief-complaints",
            tabindex: "-1",
            "data-focus-on": "input:first",
            role: "dialog",
            "data-backdrop": "static",
            "data-keyboard": "false",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog grt-md wd-770" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _c("div", { staticClass: "modal-body px-60" }, [
                _c("h4", { staticClass: "modal-title" }, [
                  _vm._v("Chief Complaints"),
                ]),
                _c(
                  "div",
                  {
                    ref: "dropdownWrapper",
                    staticClass: "chief-complaints-wrapper",
                  },
                  [
                    _c("div", { staticClass: "input-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "chips" },
                        [
                          _vm._l(_vm.chips, function (chip, index) {
                            return _c(
                              "span",
                              { key: index, staticClass: "chip" },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(chip) +
                                    "\n                                    "
                                ),
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeChip(index)
                                      },
                                    },
                                  },
                                  [_vm._v("✕")]
                                ),
                              ]
                            )
                          }),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.displaySearch,
                                expression: "displaySearch",
                              },
                            ],
                            ref: "searchInput",
                            staticClass: "chip-input",
                            attrs: {
                              type: "text",
                              maxlength: "100",
                              placeholder:
                                _vm.chips.length === 0
                                  ? "Chief complaints"
                                  : "Add more",
                            },
                            domProps: { value: _vm.displaySearch },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.addChipFromInput.apply(
                                  null,
                                  arguments
                                )
                              },
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.displaySearch = $event.target.value
                                },
                                _vm.onInputChange,
                              ],
                            },
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm.dropdownVisible
                      ? _c(
                          "div",
                          { staticClass: "dropdown" },
                          [
                            _c("div", { staticClass: "radio-options" }, [
                              _c("label", { staticClass: "radio-label" }, [
                                _c("input", {
                                  attrs: { type: "radio", name: "checkAll" },
                                  on: { change: _vm.selectAll },
                                }),
                                _vm._v(
                                  "\n                                    Check all\n                                "
                                ),
                              ]),
                              _c("label", { staticClass: "radio-label" }, [
                                _c("input", {
                                  attrs: { type: "radio", name: "checkAll" },
                                  on: { change: _vm.unselectAll },
                                }),
                                _vm._v(
                                  "\n                                    Uncheck all\n                                "
                                ),
                              ]),
                            ]),
                            _vm._l(_vm.filteredList, function (item, index) {
                              return _c("div", { key: index }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "dropdown-option-label",
                                    class: {
                                      disabled: _vm.chips.includes(item),
                                    },
                                  },
                                  [
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        value: item,
                                        checked: _vm.chips.includes(item),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.toggleChip(item)
                                        },
                                      },
                                    }),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.highlightMatch(item)
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ])
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "height-dft",
                    class: { "error-msg-hold": _vm.Validatenote },
                  },
                  [
                    _c("span", { staticClass: "error" }, [
                      _vm._v("Please select at least one item."),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "modal-footer px-60" }, [
                _c(
                  "button",
                  {
                    staticClass: "secondary-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.clearAllChips },
                  },
                  [_vm._v("Clear All")]
                ),
                _c("span", [_vm._v(_vm._s(_vm.search))]),
                _c(
                  "button",
                  {
                    staticClass: "primary-btn ripple",
                    attrs: { type: "button" },
                    on: { click: _vm.save },
                  },
                  [_vm._v("Save")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("Messages", {
            attrs: {
              datamessage: _vm.sucessmsgtext,
              iserror: _vm.iserrormsg,
              isVisible: _vm.isdisplaymsg,
            },
            on: { closemsg: _vm.closeMessage },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "data-dismiss": "modal", id: "closebutton" },
        },
        [_vm._v("×")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }